import {TableDefinition} from '../../models';

export const MESSAGE_CAMPAIGN_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.MessageCampaign.id',
    prop: 'id',
    visible: false,
    objectName: 'MessageCampaign',
    searchFieldType: 'NUMBER',
  },
  {
    key: 'API.fields.MessageCampaign.name',
    prop: 'name',
    visible: true,
    objectName: 'MessageCampaign',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.MessageCampaign.typeLabel',
    prop: 'type',
    visible: true,
    valueKeyPrefix: 'API.types.MessageCampaign.type',
  },
  {
    key: 'API.fields.MessageCampaign.language',
    prop: 'language',
    visible: true,
  },
  {
    key: 'API.types.MessageCampaign.statistics.numberOfOrderedMessages',
    prop: 'ordered',
    visible: true,
    sortDisabled: true,
  },
  {
    key: 'API.types.MessageCampaign.statistics.numberOfSentMessages',
    prop: 'sent',
    visible: true,
    sortDisabled: true,
  },
  {
    key: 'API.types.MessageCampaign.statistics.numberOfOpenedMessages',
    prop: 'opened',
    visible: true,
    sortDisabled: true,
  },
  {
    key: 'API.types.MessageCampaign.statistics.numberOfCancelledMessages',
    prop: 'canceled',
    visible: true,
    sortDisabled: true,
  },
  {
    key: 'API.fields.MessageCampaign.dateStartUTC',
    prop: 'dateStartUTC',
    visible: true,
    dateFormat: 'short',
  },
  {
    key: 'API.fields.MessageCampaign.lastModifiedAtUTC',
    prop: 'lastModifiedAtUTC',
    visible: true,
    dateFormat: 'short',
  },
  {
    key: 'API.types.MessageCampaign.statistics.status',
    prop: 'status',
    visible: true,
    valueKeyPrefix: 'API.types.MessageCampaign.status',
  },
];
